const releaseInfo = {
    buildId: '1.7.25',
    name: 'Atlas',
    commit: '#commitId#'
};
export default releaseInfo;
